import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import subscriptions from 'modules/billing/store/collections/subscriptions'
import useUserSegmentations from 'modules/onboarding/hooks/userSegmentations/useUserSegmentations'

import FeaturesSection from './_FeaturesSection'
import HubsSectionTitle from './_HubsSectionTitle'
import PricingSection from './_PricingSection'

const PersonalisedHub = ({ hubsSectionRef }: { hubsSectionRef: React.RefObject<HTMLElement> }) => {
  const isInFreeTrial = subscriptions.current.inFreeTrial
  const { interestingSections } = useUserSegmentations()

  if (!interestingSections.length || !isInFreeTrial) return null

  return (
    <>
      <Box
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{ all: 'abs016' }}
        width="full"
        alignSelf="center"
        flexDirection="row"
        style={{ maxWidth: '1120px' }}
      >
        <PricingSection hubsSectionRef={hubsSectionRef} />
        <FeaturesSection />
      </Box>
      <HubsSectionTitle />
    </>
  )
}

export default PersonalisedHub
